import { Modal } from '@ddg-frontend/blocks/ui-components'
import { useRef } from 'react'
import { useApp } from './app-context'
import channels from '../assets/channels.svg'
import { Link } from 'react-router-dom'
import { getResource } from '../utils'
export const ChannelModal = () => {
  const modalRef = useRef<{
    handlerModalAction: (type: 'OPEN' | 'CLOSE') => void
  }>(null)
  const lastFocusedButtonRef = useRef<HTMLButtonElement | null>(null)

  const handleOpenModal = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    lastFocusedButtonRef.current = event.currentTarget
    modalRef.current?.handlerModalAction('OPEN')
  }
  const handleCloseModal = () => {
    modalRef.current?.handlerModalAction('CLOSE')
  }
  const language = window.ISites.WegLot?.GetCurrentLanguage() || 'PT'

  const { channelData } = useApp()
  return (
    <>
      <button type="button" onClick={handleOpenModal}>
        <img src={channels} alt="Canais" />
        <span className="screen-readers-only">Ver lista de canais</span>
      </button>
      <Modal
        ref={modalRef}
        modalRoot={document.body}
        onAfterClose={() => {
          if (lastFocusedButtonRef.current) {
            lastFocusedButtonRef.current.focus()
          }
        }}
      >
        <div className="channels-modal">
          <h2 className="channels-modal-title">
            {getResource('ChannelModal.Title')}
          </h2>
          <ul className="channels-grid">
            {channelData?.map((channel) => {
              //const ImageWrapper = channel.isAdult ? 'span' : Link

              return (
                <li key={channel.callLetter} className="channel-item">
                  <div className="channel">
                    <span className="channel-position">
                      {channel.channelPosition}
                    </span>
                    <Link
                      to={`/${language === 'EN' ? 'channel' : 'canal'}/${
                        channel.callLetter
                      }`}
                      title={`ver detalhes do canal ${channel.title}`}
                      className="channel-link"
                      onClick={handleCloseModal}
                      reloadDocument
                    >
                      <img
                        //lazy solution to increase image quality
                        src={`${channel.logoUrl}0`}
                        alt={`logo ${channel.title}`}
                        loading="lazy"
                        className="channel-logo"
                      />
                    </Link>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </Modal>
    </>
  )
}
